/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import { SketchPicker } from "react-color";
import ValidateItem from "../../../helpers/validation/validateInput";
import GetItem from "../../../helpers/dataProviders/getItem";
import { Checkboard } from "react-color/lib/components/common";
import validatehoc from "../Validator";

class ColorPicker extends Component {
	constructor(props) {
		super(props);
		let rgba = {
			r: 41,
			g: 47,
			b: 193,
			a: 1,
		};
		if (props.fieldState.value && props.fieldState.value !== "") {
			let parts = props.fieldState.value
				.substring(5, props.fieldState.value.length - 1)
				.replace(/ /g, "")
				.split(",");
			rgba = {
				r: parts[0],
				g: parts[1],
				b: parts[2],
				a: parts[3],
			};
		}
		this.state = {
			minimizePlaceholder: false,
			themeId: props.themeId,
			themeColors: [],
			showPicker: false,
			rgba,
		};
	}
	componentDidMount() {
		const { themeId } = this.state;
		if (themeId && themeId !== "") {
			GetItem(`/themes/${themeId}`).then(data => {
				this.getThemeColors(data.data);
			});
		}
	}

	togglePicker = () => {
		this.setState({ showPicker: !this.state.showPicker });
	};

	shouldComponentUpdate(nextProps) {
		const { themeId } = this.state;
		let newThemeId = nextProps.themeId;
		if (themeId !== newThemeId) {
			this.setState({ themeId: newThemeId });
			GetItem(`/themes/${newThemeId}`).then(data => {
				this.getThemeColors(data.data);
			});
		}
		return true;
	}

	handleClick = () => {
		this.setState({ displayColorPicker: !this.state.displayColorPicker });
	};

	handleClose = () => {
		this.setState({ displayColorPicker: false });
	};

	handleChange = color => {
		let { r, g, b, a } = color.rgb;
		this.setState({ rgba: color.rgb });
		this.props.fieldApi.setValue(`rgba(${r},${g},${b},${a})`);
		this.props.fieldApi.setTouched(true);
	};

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	getThemeColors = theme => {
		const unique = (value, index, self) => {
			return self.indexOf(value) === index;
		};
		let stringTheme = JSON.stringify(theme);
		const regex = /rgba\(\s*(-?\d+|-?\d*\.\d+(?=%))(%?)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*\.\d+(?=%))(\2)\s*,\s*(-?\d+|-?\d*.\d+)\s*\)/g;
		const themeColors = stringTheme.match(regex).filter(unique);
		this.setState({ themeColors });
	};

	render() {
		const { fieldState, placeholder, helperText, isRequired } = this.props;
		const { value, error } = fieldState;
		const shouldFocus = value && value !== "";
		const isFocused = shouldFocus ? " focus" : "";
		const hasError = error ? " has-error" : "";
		return (
			<div className="color-picker-input">
				<div className={`input-wrap${isFocused}${hasError}`}>
					<div className="placeholder">
						<span className={shouldFocus ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</span>
					</div>
					<input className="dummy-input" onFocus={() => this.togglePicker()} />
					<div className="color-picker-value" onClick={() => this.togglePicker()}>
						<div className="color-preview">
							<div className="color-preview-value" style={{ backgroundColor: value }}></div>
							{value && value !== "" && <Checkboard size={12} white="#ffffff" grey="#cccccc" />}
						</div>
					</div>
					<div
						className={`coverall ${this.state.showPicker ? "on" : ""}`}
						onClick={() => this.togglePicker()}
					></div>
					<div className={`input-modal ${this.state.showPicker ? "on" : "off"}`}>
						<SketchPicker
							color={this.state.rgba}
							presetColors={this.state.themeColors}
							onChangeComplete={this.handleChange}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-6">
						<div className="caption-text helper-message">{helperText}</div>
					</div>
					<div className="col-xs-6">
						<div className="error-message caption-text">{error ? error : ""}</div>
					</div>
				</div>
			</div>
		);
	}
}

ColorPicker.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	helperText: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	themeId: PropTypes.string,
	fieldState: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <ColorPicker fieldState={fieldState} {...props} />),
	"object"
);

export default Wrapper;
